import { Store } from 'pullstate';
import { func, types } from 'utils';

const user = func.mapUser(func.getStorageJson('user') || {});
const token = func.getStorageJson('token') || '';
const activeStore: types.Store = func.getStorageJson('activeStore') || {
	delivery: { schedule: {} },
};

const filterDefault = {
	tags: [],
	minPrice: '',
	maxPrice: '',
	drinks: [],
	stores: [],
	cuisines: [],
	categories: [],
};
const cartDefault = {
	items: [],
	store: {},
	paymentType: 'ADVANCE',
	delivery: { channel: '', instructions: '' },
	quantity: 0,
	deliveryFee: 0,
	voucher: '',
	discount: 0,
};

const initialState = {
	__auth: {
		user,
		token,
		isLoggedIn: !!(user && user.id && token),
		favorites: (func.getStorageJson('favorites') || []) as types.Item[],
	},
	__data: {
		home: {},
		phones: {
			// br: { code: '+55', phoneLength: 12 },
			NG: { code: '+234', phoneLength: 11 },
			GH: { code: '+233', phoneLength: 10 },
			// ke: { code: '+254', phoneLength: 10 },
			// ie: { code: '+353', phoneLength: 10 },
			// ci: { code: '+225', phoneLength: 9 },
			// ae: { code: '+971', phoneLength: 10 },
		},
		cartDefault,
		cart: func.getStorageJson('cart') || cartDefault,
		item: {} as types.Item,
		order: func.getStorageJson('order') || {},
		options: [
			{ key: types.OrderTypes.PICKUP, label: 'Pick Up' },
			{ key: types.OrderTypes.DELIVERY, label: 'Delivery' },
		],
		filter: (func.getStorageJson('filter') ||
			filterDefault) as typeof filterDefault,
		settings: func.getStorageJson('settings') || {},
		categories: func.getStorageJson('categories') || [],
		deliveryFees: func.getStorageJson('deliveryFees') || [],
		deliveryPartners: func.getStorageJson('deliveryPartners') || [],
		filterDefault,
		activeStore,
		location: func.getStorageJson('location') || {
			option: types.OrderTypes.DELIVERY,
			radius: 30,
			address: {},
		},
		paymentOptions: [
			{
				code: types.OrderPaymentTypes.ADVANCE,
				label: 'Bank Transfer / Visa / MasterCard',
			},
		],
		orderStatus: {
			[types.OrderStatus.new]: { c: `warning`, t: `Processing` },
			[types.OrderStatus.ready]: { c: `warning`, t: `Ready` },
			[types.OrderStatus.timeout]: { c: `danger`, t: `Cancelled` },
			[types.OrderStatus.payment]: { c: `warning`, t: `Pending` },
			[types.OrderStatus.rejected]: { c: `danger`, t: `Cancelled` },
			[types.OrderStatus.accepted]: { c: `warning`, t: `Preparing` },
			[types.OrderStatus.preparing]: { c: `warning`, t: `Preparing` },
			[types.OrderStatus.delivery]: { c: `warning`, t: `In Transit` },
			[types.OrderStatus.arrived]: { c: `warning`, t: `Arrived` },
			[types.OrderStatus.completed]: { c: `success`, t: `Completed` },
			[types.OrderStatus.cancelled]: { c: `danger`, t: `Cancelled` },
			[types.OrderStatus.unclaimed]: { c: `danger`, t: `Unclaimed` },
			[types.OrderStatus.rider_pending]: {
				c: 'warning',
				t: `Looking for rider`,
			},
			[types.OrderStatus.rider_unavailable]: {
				c: `warning`,
				t: `We couldn't find a rider`,
			},
		} as Record<types.OrderStatus, { c: string; t: string }>,
		promo_cart: {
			items: [],
		},
		promotions: func.getStorageJson('promotions') || [],
		stores: func.getStorageJson('stores') || [],
		cache: {
			user: '',
		},
		is_bottom_modal: {
			is_open: false,
		},
	},
};

if (['live', 'staging', 'local'].includes(func.config.env)) {
	// initialState.__data.paymentOptions = initialState.__data.paymentOptions.concat({ code: 'delivery', label: 'Payment on delivery' });
}

export const _store = new Store<types.StoreProps>(initialState);

export const _update = {
	auth: (key: keyof typeof initialState.__auth, data: any) => {
		_store.update((s) => {
			func.setStorageJson(key, data);
			if (key === 'user') {
				data = func.mapUser(data);
			}
			// @ts-ignore
			s.__auth[key] = data;
			s.__auth['isLoggedIn'] = !!(
				s.__auth.user &&
				s.__auth.user.id &&
				s.__auth.token
			);
		});
	},
	data: (key: keyof typeof initialState.__data, data: any) => {
		_store.update((s) => {
			// key === 'cart' && console.log(data);
			if (
				![
					'countries',
					'categories',
					'deliveryPartners',
					'promotions',
					'deliveryFees',
					'stores',
				].includes(key)
			) {
				data = { ...s.__data[key], ...data };
			} else if (JSON.stringify(data) === '{}') {
				data = {};
			}
			s.__data[key] = data;
		});
		!['promotions'].includes('key') && func.setStorageJson(key, data);
	},
};
